import { SettingsIcon } from "./icons";
import { localTenantChanged } from "../features/tenant/tenantSlice";
import { selectLocalTenantHost } from "../features/tenant/tenantSelectors";
import { isLocalHost } from "../lib/env";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { LocalTenantSwitcher } from "./LocalTenantSwitcher";

export function LocalDevelopmentTools() {
  const dispatch = useAppDispatch();
  const localTenantHost = useAppSelector(selectLocalTenantHost);

  if (!isLocalHost()) return null;

  return (
    <aside class="local-development-tools" aria-label="Local development">
      <details
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            event.currentTarget.open = false;
            event.currentTarget.querySelector("summary")?.focus();
          }
        }}
      >
        <summary aria-label="Local development tools" title="Local development tools">
          <SettingsIcon size={18} />
        </summary>
        <div class="local-development-panel">
          <h2>Local development</h2>
          <LocalTenantSwitcher
            selectedHost={localTenantHost}
            onChange={(host) => dispatch(localTenantChanged(host))}
          />
        </div>
      </details>
    </aside>
  );
}
